<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'text-two-column-fi': true,
        'text-two-column-fi--dark': isDark,
      }"
    >
      <div
        v-if="fields.textTop || isEditMode"
        :class="{
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12': true,
          'lg:fi-col-start-2 lg:fi-col-end-12': isWideContent,
          'lg:fi-col-start-3 lg:fi-col-end-11': !isWideContent,
        }"
      >
        <richtext-fi
          :html-content="fields.textTop"
          :is-bg-dark="isDark"
        />
      </div>
      <div
        :class="{
          'fi-col-start-1 fi-col-end-13 sm:fi-col-start-1 sm:fi-col-end-7 md:fi-col-start-2 md:fi-col-end-7': true,
          'lg:fi-col-start-2 lg:fi-col-end-7': isWideContent,
          'lg:fi-col-start-3 lg:fi-col-end-7': !isWideContent,
        }"
      >
        <richtext-fi
          :html-content="fields.textLeft"
          :is-bg-dark="isDark"
        />
      </div>
      <div
        :class="{
          'fi-col-start-1 fi-col-end-13 sm:fi-col-start-7 sm:fi-col-end-13 md:fi-col-start-7 md:fi-col-end-12 lg:fi-col-start-7': true,
          'lg:fi-col-end-12': isWideContent,
          'lg:fi-col-end-11': !isWideContent,
        }"
      >
        <richtext-fi
          :html-content="fields.textRight"
          :is-bg-dark="isDark"
        />
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { RichtextFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import ssrOnlyMixin from '@/mixins/ssrOnlyMixin.vue';

export default {
  name: 'TextTwoColumnFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    RichtextFi,
  },
  mixins: [ssrOnlyMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isWideContent() {
      return this.fields.wideContent && Boolean(this.fields.wideContent.value);
    },
    isDark() {
      return this.fields.dark?.value;
    },
  },
};
</script>

<style scoped src="./text-two-column-fi" />
